import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to the top of the page on route change
function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

export default ScrollToTop;
